module.exports = __webpack_public_path__ + "media/images/riders/small/GEORGE_BANNIGAN-f054d98cef6a62f86fe3910b2d65d5cb.png";